import { atom , useSetRecoilState, useRecoilValue} from "recoil";


 const editCustomerAtom = atom({key:'editCustomer',default:{}});

 const customerSearchListAtom = atom({key:'customerSearchAtom',default:[]});


 const customerListAtom = atom({key:'customer_list',default:{customer_info:[], customer_count_info:[ {
    "Today": 0,
    "Last_7_days": 0,
    "Last_30_days": 0,
    "Last_365_days": 0,
    "All_Customer": 0
}]}});


export const customerDetailsAtom = atom({key:'customerDetailsAtom',default:{}});
export const customerTableHeaderAtom = atom({key:'customerTableHeaderAtom',default:[]});

export  const SetCustomerEditAtom = () => useSetRecoilState(editCustomerAtom);
export  const GetCustomerEditAtom = () => useRecoilValue(editCustomerAtom);

export  const SetCustomerList2 = () => useSetRecoilState(customerListAtom);
export  const GetCustomerList2 = () => useRecoilValue(customerListAtom);

export  const SetCustomerSearchList = () => useSetRecoilState(customerSearchListAtom);
export  const GetCustomerSearchList = () => useRecoilValue(customerSearchListAtom);



